import * as React from "react";
import UserPresenterComponent from "./UserPresenterComponent";

interface IProps {
	value: string;
}

export const UserPresenter: React.SFC<IProps> = (props) => {
	return (
		<UserPresenterComponent userId={props.value}/>
	);
};